module.exports = __webpack_public_path__ + "img/stapel-04.18c202f9.svg";